export class DateFormat {
  static readonly FULL_DATE_HOURS_A: string = 'MM/DD/YYYY, hh:mm:ss A';
  static readonly FULL_DATE_HOURS_A_WITH_LEADING_ZEROS: string = 'M/d/yyyy, hh:mm:ss a';
  static readonly FULL_LONG_DATE: string = 'MMM DD, YYYY';
  static readonly FULL_DATE: string = 'MM/DD/YYYY';
}
